import http from "../http-common";
import authHeader from './auth-header';

const API_URL = '/test/';

class UserService {
  getPublicContent() {
    return http.get(API_URL + 'all');
  }

  getUserBoard() {
    return http.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return http.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return http.get(API_URL + 'admin', { headers: authHeader() });
  }

  getFamilyBoard() {
    return http.get(API_URL + 'families', { headers: authHeader() });
  }

  // Given an ID, this method retrieves the user details
  getUserById(id) {
    return http.get(API_URL + `users/${id}`, { headers: authHeader() });
  }

  // Edit user details
  editUser(id, userData) {
    return http.put(API_URL + `users/${id}`, userData, { headers: authHeader() });
  }

}

export default new UserService();
